import { JSX } from "react";

import {
  AttributeControlProps,
  Radios,
} from "@plansoft-configuration-renderer/components";

export function CustomRadio(props: AttributeControlProps): JSX.Element {
  const { children } = props;
  return <Radios>{children}</Radios>;
}
